export default {
  UsernameFormField__ARIA_LABEL: "Username",
  UsernameFormField__LABEL: "Username",
  UsernameFormField__TEXT_USERNAME_REQUIRES_ALPHA: "The username must contain at least one letter.",
};
